import { checkNamedModelNameRequest } from 'api/Exec/api';
import getErrorFromPromiseReason from 'app/helpers/getErrorFromPromiseReason';

import { message, notification } from 'antd';
import { useState } from 'react';

const useCheckNamedModelName = () => {
  const [ isChecking, setIsChecking ] = useState<boolean>(false);

  const checkNamedModelName = (name: string) => {
    setIsChecking(true);

    checkNamedModelNameRequest(name)
      .then(({ data }) => {
        if (data.length === 0) {
          message.success('The model name is free');
        } else {
          message.error('The model name already exists');
        }
      })
      .catch((reason) => {
        notification.error({ duration: 0, type: 'error', message: getErrorFromPromiseReason(reason) });
      })
      .finally(() => {
        setIsChecking(false);
      });
  };

  return { isChecking, checkNamedModelName };
};

export default useCheckNamedModelName;
